export default "__VITE_ASSET__42959cfa__"